import React from 'react';
import { useTranslation } from 'react-i18next';
import Radio from 'apollo-react/components/Radio';
import styles from './StrategyRadioCard.module.css';

const StrategyRadioCard = ({
  value,
  selected,
  onSelect,
  labelKey,
  descriptionKey,
}) => {
  const { t } = useTranslation();
  const cardClass = selected
    ? `${styles.card} ${styles.cardSelected}`
    : styles.card;

  return (
    <div onClick={() => onSelect(value)} className={cardClass}>
      <Radio
        value={value}
        checked={selected}
        onChange={() => onSelect(value)}
        label={
          <div>
            <div className={styles.label}>{t(labelKey)}</div>
            <div className={styles.description}>{t(descriptionKey)}</div>
          </div>
        }
      />
    </div>
  );
};

export default StrategyRadioCard;
